module.exports = __webpack_public_path__ + "img/printPromo.0bfa6b31.svg";